const actionTypes = {
    GET_USER_INFO_SUCCESS: 'GET_USER_INFO_SUCCESS',
    GET_USER_INFO_FAILURE: 'GET_USER_INFO_FAILURE',
    GET_USERS_SUCCESS: 'GET_USERS_SUCCESS',
    GET_USERS_FAILURE: 'GET_USERS_FAILURE',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    GET_ALL_EN_USERS_SUCCESS: 'GET_ALL_EN_USERS_SUCCESS',
    GET_ALL_EN_ROLES_SUCCESS: 'GET_ALL_EN_ROLES_SUCCESS',
    GET_ALL_EN_APPLICATIONS_SUCCESS: 'GET_ALL_EN_APPLICATIONS_SUCCESS',
    GET_ALL_EN_DASHBOARD_SUCCESS: 'GET_ALL_EN_DASHBOARD_SUCCESS',
    GET_ALL_EN_ROUTES_SUCCESS: 'GET_ALL_EN_ROUTES_SUCCESS',
    SET_ARRAY_SUCCESS: 'SET_ARRAY_SUCCESS',
    UPDATE_ONCHANGE_CAPTURE_ROUTE_PERMISSIONS: 'UPDATE_ONCHANGE_CAPTURE_ROUTE_PERMISSIONS',
    GET_USER_DETAILS_SUCCESS: 'GET_USER_DETAILS_SUCCESS',
    GET_APPLICATION_SCREEN_PERMISSION_SUCCESS: 'GET_APPLICATION_SCREEN_PERMISSION_SUCCESS',
    GET_ALL_ACTIVITY_LOGS: 'GET_ALL_ACTIVITY_LOGS',
};

export default actionTypes;
